const ORGAN_DISPLAY_NAME_OVERRIDES: Record<string, string> = {
  bladder_and_ureters: 'Bladder',
  prostate: 'Prostate and testicles',
};

export const parseOrganTitle = (organ: string) => {
  if (ORGAN_DISPLAY_NAME_OVERRIDES[organ]) {
    return ORGAN_DISPLAY_NAME_OVERRIDES[organ];
  }

  const organName = organ.split('_').join(' ');

  return organName.charAt(0).toUpperCase() + organName.slice(1);
};
